<script>
import $ from 'jquery';

/* COMPOSANTS */
import AkFormSubmitted from '@components/general/AkFormSubmitted';
import GaMessages from '@components/ga/layout/GaMessages';
import AkButtonValidationV2 from '@components/v2/general/AkButtonValidationV2.vue';

/* MIXINS */

/* SERVICES */

export default {
  components: {AkButtonValidationV2, AkFormSubmitted, GaMessages},
  props: {
    title: {type: String, required: true},
    width: {type: String, default: '600px'},
    cancelLabel: {type: String, default: undefined},
    validateLabel: {type: String, default: undefined},
    autoHideOnValidate: {type: Boolean, default: false},
    autoHideOnCancel: {type: Boolean, default: true},
    showValidateButton: {type: Boolean, default: true},
    showCancelButton: {type: Boolean, default: true},
    dismissable: {type: Boolean, default: false},
    titleClass: {type: String, required: false, default: ''},
  },
  emits: ['show', 'hide', 'cancel', 'validate'],
  data() {
    return {
      display: false,
      submitted: false,
    };
  },
  computed: {
    buildCancelLabel() {
      return this.cancelLabel ? this.cancelLabel : this.$t('cancel');
    },
    buildValidateLabel() {
      return this.validateLabel ? this.validateLabel : this.$t('validate');
    },
  },
  mounted() {},
  methods: {
    init() {
      if (this.$refs.btnValid) this.$refs.btnValid.init();
    },
    show() {
      this.submitted = false;
      this.setDisplay(true);
      this.$emit('show');
    },
    hide() {
      this.setDisplay(false);
      this.$emit('hide');
    },
    cancel() {
      if (this.autoHideOnCancel) this.setDisplay(false);
      this.$emit('cancel');
    },
    validate() {
      this.submitted = true;
      if (this.autoHideOnValidate) this.setDisplay(false);
      this.$emit('validate');
    },
    setDisplay(value) {
      this.display = value;
    },
    success(msg) {
      this.$refs.messages.success(msg);
      this.init();
      this.scrollTop();
    },
    error(msg) {
      this.$refs.messages.error(msg);
      this.init();
      this.scrollTop();
    },
    resetMessages() {
      this.$refs.messages.resetMessages();
    },
    scrollTop() {
      $('.p-dialog-content').scrollTop(0);
    },
  },
};
</script>

<template>
  <PDialog
    v-model:visible="display"
    :modal="true"
    :pt="{
      mask: {class: 'headless'},
    }"
    class="dialog-headless"
    :dismissable-mask="dismissable"
    :style="{width: width}"
    @hide="cancel"
    :class="{'no-footer': !this.showCancelButton && !this.showValidateButton && !this.$slots.footer}">
    <perfect-scrollbar class="max-h-[70dvh] w-full" :options="{suppressScrollX: true, scrollYMarginOffset: 1}">
      <span
        v-if="title"
        class="font-inter font-bold text-xl text-grey-900 flex items-center justify-center mb-4"
        :class="titleClass"
        >{{ title }}</span
      >
      <GaMessages ref="messages" />

      <AkFormSubmitted :submitted="submitted" reference="form">
        <slot />
      </AkFormSubmitted>
    </perfect-scrollbar>

    <template #footer>
      <div v-if="this.showCancelButton || this.showValidateButton" class="flex justify-between gap-4 w-full">
        <span v-if="this.showCancelButton" class="btn-secondary-inverse flex-1" @click="cancel">
          {{ buildCancelLabel }}
        </span>
        <AkButtonValidationV2
          ref="btnValid"
          btn-class="btn-blue flex-1"
          :label="buildValidateLabel"
          :little="false"
          v-if="this.showValidateButton"
          @action="validate">
        </AkButtonValidationV2>
      </div>
      <slot v-else name="footer" />
    </template>
  </PDialog>
</template>
